import { combineReducers } from "redux";
import amppaAuthReducer from "./amppaAuthReducer";
import authLoginReducer from "./authLoginReducer";
import checkUsernameReducer from "./checkUsernameReducer";
import checkPasswordReducer from "./checkPasswordReducer";
import registerUserResponseReducer from "./registerUserReducer";
import rollLoginReducer from "./rollLoginReducer";
import { tokenReducer } from "./tokenReducer";
import getUserInfoReducer from "./getUserInfoReducer";
import getSecurityQuestionReducer from "./getSecurityQuestionReducer";
import getSecurityQuestionsReducer from "./getSecurityQuestionsReducer";
import updateUserInfoReducer from "./updateUserInfoReducer";
import { initPasswordResetReducer, resetPasswordFinishReducer, resetPasswordResponseReducer } from "./resetPasswordReducer";
import getMasqueradeReducer from "./masqueradeReducer";
import verifyEmailReducer from "./verifyEmailReducer";
import resendEmailReducer from "./resendVerifyEmailReducer";
import { getSurveyReducer } from "./surveyReducer";
import refreshReducer from "./refreshReducer";


const authReducer = combineReducers({
    amppa: amppaAuthReducer,
    login: authLoginReducer,
    rollLogin: rollLoginReducer,
    usernameCheck: checkUsernameReducer,
    passwordCheck: checkPasswordReducer,
    registration: registerUserResponseReducer,
    token: tokenReducer,
    getUser: getUserInfoReducer,
    getSecurityQuestion: getSecurityQuestionReducer,
    getSecurityQuestions: getSecurityQuestionsReducer,
    updateUser: updateUserInfoReducer,
    reset: combineReducers ({
        question: resetPasswordResponseReducer,
        finish: resetPasswordFinishReducer,
        begin: initPasswordResetReducer
    }),
    masquerade: getMasqueradeReducer,
    verify: verifyEmailReducer,
    resend: resendEmailReducer,
    survey: getSurveyReducer,
    refresh: refreshReducer
});

export default authReducer;